import React from 'react';
import { List, Typography, useTheme } from '@mui/material';
import { SideBarListItem } from './SideBarListItem';
import { useSideNavStyle } from './useSideNavStyle';

const Header = ({ text }) => {
	const theme = useTheme();
	const { inverted } = useSideNavStyle();
	const color = inverted ? theme.palette.sideNav : 'rgba(250, 253, 255, 0.8)';

	return (
		<Typography
			variant='subtitle2'
			sx={{
				color,
				marginLeft: '35px',
				paddingTop: '1.75em',
				fontSize: '0.75rem',
				paddingBottom: '8px',
				textTransform: 'uppercase',
				letterSpacing: '0.08em',
			}}
		>
			{text}
		</Typography>
	);
};

/**
 * A side nav list with an optional heading, which is hidden while the nav is collapsed.
 */
export const SideNavSection = ({ title, items }) => {
	const { collapsed } = useSideNavStyle();

	return (
		<List disablePadding>
			{title && !collapsed && <Header text={title} />}
			{items.map((item, index) => (
				<SideBarListItem key={`side-bar-list-item-${index}-${item.text}`} item={item} />
			))}
		</List>
	);
};
